export default {
  props: {
    agro_exporter_id: {}, // se obtiene por el path url
    agro_exporter_process_id: {}, // se obtiene por el path url
  },
}
